export { IFiltersConfig } from './filters-config';
export { FilterMetadata } from './metadata/filter-metadata.interface';
export { EnumFilterMetadata } from './metadata/enum-filter-metadata';
export { SliderFilterMetadata } from './metadata/slider-filter-metadata';
export { Filter } from './filter';



// WEBPACK FOOTER //
// C:/Users/user/projects/ansyn/src/app/packages/menu-items/filters/models/index.ts